import { update } from "../../services/pinwall";
import { setHeaders, getQueryString } from "../../utils/fetch";

const getters = {
  pinwall: state => state.pinwall,
  sort: state => state.sort,
  viewHeight: state => state.viewHeight,
  searchPosts: state => state.searchPosts,
  playingPost: state => state.playingPost
};

const actions = {
  createPost(context, data) {
    const scrollPosition = window.scrollY + window.innerHeight;
    const queryString = getQueryString(
      null,
      context.getters.sort,
      window.innerWidth,
      data.view,
      context.state.viewHeight > scrollPosition
        ? context.state.viewHeight
        : scrollPosition
    );
    data.windowWidth = window.innerWidth;
    data.password = data.password || context.getters.pinwall.password;
    return new Promise((resolve, reject) => {
      fetch(
        `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/api/post?${queryString}`,
        {
          method: "post",
          headers: setHeaders(
            {
              "Content-Type": "application/json"
            },
            context.getters.user
          ),
          body: JSON.stringify(data)
        }
      )
        .then(res => {
          return res.json();
        })
        .then(function(data) {
          context.commit("setPosts", data);
          resolve(data);
        })
        .catch(e => {
          window.console.error(e);
          reject();
        });
    });
  },
  updatePost(context, data) {
    const scrollPosition = window.scrollY + window.innerHeight;
    const queryString = getQueryString(
      null,
      context.getters.sort,
      window.innerWidth,
      data.view,
      context.state.viewHeight > scrollPosition
        ? context.state.viewHeight
        : scrollPosition
    );
    data.windowWidth = window.innerWidth;
    data.password = data.password || context.getters.pinwall.password;
    return new Promise((resolve, reject) => {
      data.windowWidth = window.innerWidth;
      data.hlsInstance = null;

      fetch(
        `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/api/post?${queryString}`,
        {
          method: "put",
          headers: setHeaders(
            {
              "Content-Type": "application/json"
            },
            context.getters.user
          ),
          body: JSON.stringify(data)
        }
      )
        .then(res => {
          return res.json();
        })
        .then(function(data) {
          context.commit("setPosts", data);
          resolve(data);
        })
        .catch(e => {
          window.console.error(e);
          reject();
        });
    });
  },
  deletePost(context, data) {
    const scrollPosition = window.scrollY + window.innerHeight;
    return new Promise((resolve, reject) => {
      data.hlsInstance = null;
      const queryString = getQueryString(
        null,
        context.getters.sort,
        window.innerWidth,
        data.view,
        context.state.viewHeight > scrollPosition
          ? context.state.viewHeight
          : scrollPosition
      );
      fetch(
        `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/api/post?${queryString}`,
        {
          method: "delete",
          headers: setHeaders(
            {
              "Content-Type": "application/json"
            },
            context.getters.user
          ),
          body: JSON.stringify(data)
        }
      )
        .then(res => {
          return res.json();
        })
        .then(function(data) {
          context.commit("setPosts", data);
          resolve(data);
        })
        .catch(e => {
          window.console.error(e);
          reject();
        });
    });
  },
  getSearchPosts(context, data) {
    const scrollPosition = window.scrollY + window.innerHeight;
    return new Promise(resolve => {
      const queryString = getQueryString(
        null,
        data.sort,
        window.innerWidth,
        data.view,
        context.state.viewHeight > scrollPosition
          ? context.state.viewHeight
          : scrollPosition,
        null,
        data.showItems
      );
      fetch(
        `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/api/post/search?searchValue=${
          data.searchValue
        }&tenantId=${data.tenantId || "pinwall"}${queryString}`,
        {
          method: "get",
          headers: setHeaders(
            {
              "Content-Type": "application/json"
            },
            context.getters.user
          )
        }
      )
        .then(res => {
          return res.json();
        })
        .then(function(data) {
          context.commit("setSearchPosts", data.posts);
          resolve(data);
        })
        .catch(e => {
          context.commit("setSearchPosts", []);
          window.console.error(e);
          resolve([]);
        });
    });
  },
  saveLayout(context, data) {
    const scrollPosition = window.scrollY + window.innerHeight;
    return new Promise((resolve, reject) => {
      const queryString = getQueryString(
        null,
        context.getters.sort,
        window.innerWidth,
        null,
        context.state.viewHeight > scrollPosition
          ? context.state.viewHeight
          : scrollPosition
      );
      fetch(
        `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/api/post/${
          data.pinwallId
        }?${queryString}`,
        {
          method: "put",
          headers: setHeaders(
            {
              "Content-Type": "application/json"
            },
            context.getters.user
          ),
          body: JSON.stringify(data.posts)
        }
      )
        .then(res => {
          return res.json();
        })
        .then(function(data) {
          context.commit("setPosts", data);
          resolve(data);
        })
        .catch(e => {
          window.console.error(e);
          reject();
        });
    });
  },
  loadPinwall(context, data) {
    if (data.mounted) {
      context.commit("setPinwall", {
        name: "",
        posts: []
      });
    }

    const scrollPosition = window.scrollY + window.innerHeight;
    return new Promise((resolve, reject) => {
      const sort = data.sort;
      const socketEmit = data.socketEmit;
      const initialLoad = data.initialLoad;
      const commit = data.commit;
      const queryString = getQueryString(
        data.password,
        sort,
        window.innerWidth,
        data.view,
        context.state.viewHeight > scrollPosition
          ? context.state.viewHeight
          : scrollPosition,
        socketEmit ? new Date().getTime() : null
      );
      fetch(
        `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/api/pinwall/${data.tenant ||
          "pinwall"}/${data.space}/${data.pinwallId}?${queryString}`,
        {
          method: "get",
          headers: setHeaders(
            {
              "Content-Type": "application/json"
            },
            context.getters.user
          )
        }
      )
        .then(res => {
          return res.json();
        })
        .then(function(data) {
          data.posts.map(post => {
            post.playMedia = false;
          });
          data.sort = sort;
          data.initialLoad = initialLoad;
          data.socketEmit = socketEmit;

          if (commit !== false) {
            context.commit("setPinwall", data);
          }
          resolve(data);
        })
        .catch(e => {
          context.commit("setPinwall", {});
          window.console.error(e);
          reject();
        });
    });
  },
  saveImage(context, image) {
    const pinwall = context.getters.pinwall;
    context.getters.pinwall.image = image;

    return new Promise((resolve, reject) => {
      update(pinwall, context.getters.user)
        .then(data => {
          context.commit("setPinwall", data);
          resolve();
        })
        .catch(e => {
          window.console.error(e);
          reject();
        });
    });
  },
  savePinwall(context, data) {
    return new Promise((resolve, reject) => {
      update(data, context.getters.user)
        .then(data => {
          context.commit("setPinwall", data);
          resolve();
        })
        .catch(e => {
          window.console.error(e);
          reject();
        });
    });
  },
  deletePinwall(context, data) {
    return new Promise((resolve, reject) => {
      fetch(
        `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/api/pinwall?password=${
          data.spacePassword
        }`,
        {
          method: "delete",
          headers: setHeaders(
            {
              "Content-Type": "application/json"
            },
            context.getters.user
          ),
          body: JSON.stringify(data)
        }
      )
        .then(res => {
          return res.json();
        })
        .then(function(data) {
          resolve(data);
        })
        .catch(e => {
          window.console.error(e);
          reject();
        });
    });
  },
  likePost(context, id) {
    return new Promise((resolve, reject) => {
      const foundLike = context.getters.storedLikes.find(like => {
        return like === id;
      });

      if (foundLike) {
        return reject();
      }
      fetch(
        `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/api/post/like/${id}`,
        {
          method: "put",
          headers: {
            "Content-type": "application/json"
          }
        }
      )
        .then(res => {
          if (!res.ok) {
            return reject();
          }
          context.commit("likePost", id);
          resolve(id);
        })
        .catch(e => {
          window.console.error(e);
          reject();
        });
    });
  },
  checkQuiz(context, data) {
    return new Promise((resolve, reject) => {
      fetch(
        `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/api/post/checkQuiz`,
        {
          method: "post",
          headers: setHeaders(
            {
              "Content-Type": "application/json"
            },
            context.getters.user
          ),
          body: JSON.stringify(data)
        }
      )
        .then(res => {
          return res.json();
        })
        .then(function(result) {
          resolve(result);
        })
        .catch(e => {
          window.console.error(e);
          reject();
        });
    });
  },
  updatePoll(context, data) {
    return new Promise((resolve, reject) => {
      fetch(
        `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/api/post/updatePoll`,
        {
          method: "post",
          headers: setHeaders(
            {
              "Content-Type": "application/json"
            },
            context.getters.user
          ),
          body: JSON.stringify(data)
        }
      )
        .then(res => {
          return res.json();
        })
        .then(function(result) {
          resolve(result);
        })
        .catch(e => {
          window.console.error(e);
          reject();
        });
    });
  },
  downloadPosts(context, data) {
    return new Promise((resolve, reject) => {
      fetch(
        `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/api/post/downloadPosts/${
          data.tenant
        }`,
        {
          method: "post",
          headers: setHeaders(
            {
              "Content-Type": "application/json"
            },
            context.getters.user
          ),
          body: JSON.stringify(data.posts)
        }
      )
        .then(response => {
          return resolve(response.blob());
        })
        .catch(e => {
          window.console.error(e);
          reject();
        });
    });
  }
};

const mutations = {
  setPinwall(state, data) {
    if (data && data.posts && (data.socketEmit || !data.initialLoad)) {
      data.posts.map(post => {
        const foundPost = state.pinwall.posts.find(item => {
          return item.id === post.id;
        });
        post.playMedia = foundPost ? foundPost.playMedia : false;
      });
    }
    Object.assign(state.pinwall, data);
    state.sort = data ? data.sort : "";
  },
  setPlayingPost(state, data) {
    state.playingPost = data;
  },
  setSearchPosts(state, data) {
    if (data) {
      data.map(post => {
        post.playMedia = false;
      });
    }
    state.searchPosts = data;
  },
  setViewHeight(state, data) {
    state.viewHeight = data;
  },
  setCommentsToPinwall(state, comments) {
    state.pinwall.posts.map(post => {
      let foundComments = comments.filter(item => {
        return item.postId === post.id;
      });
      post.comments = foundComments || [];
    });
    let foundComments = comments.filter(item => {
      return (
        item.pinwallId === state.pinwall.id &&
        (item.postId === null || item.postId === "")
      );
    });
    state.pinwall.comments = foundComments || [];
  },
  setPosts(state, data) {
    let index = 0;
    if (data) {
      data.map(post => {
        const foundPost = state.pinwall.posts.find(item => {
          return item.id === post.id;
        });
        post.playMedia = foundPost ? foundPost.playMedia : false;
        post.comments = (foundPost && foundPost.comments) || [];
        post.approved = post.approved || !state.pinwall.options.approval;
        post.i = index;
        index += 1;
      });
    }
    state.pinwall.posts = data;
  },
  likePost(state, id) {
    state.pinwall.posts.map(post => {
      if (post.id === id) {
        post.likes += 1;
      }
    });
  },
  setPlayMedia(state, data) {
    state.pinwall.posts.map(post => {
      post.playMedia = data;
    });

    if (data === false) {
      state.playingPost = null;
    }
  }
};

export default {
  state: initializeState(),
  mutations,
  actions,
  getters
};

function initializeState() {
  return {
    pinwall: {
      name: "",
      posts: []
    },
    playingPost: null,
    searchPosts: [],
    sort: "new",
    viewHeight: null
  };
}
